import type { Discipline } from '@brighterly/lib-core-types/discipline/enums'
import type { KidInCustomer } from '@brighterly/lib-core-types/kid/interfaces'
import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useCustomerStore } from '@stores/me/customer'
import { useDisciplineStore } from '@stores/discipline'
import { useKidStore } from '@stores/kid'

import { getHomeDisciplineCode } from '@auth/get-home-page-route'
import { resolveScope } from '@utils/scope/resolve-scope'

const findKidByDisciplineId = (kids: KidInCustomer[], disciplineId: number): KidInCustomer | undefined =>
  kids.find(kid => kid.disciplines.some(discipline => discipline.id === disciplineId))

export const useMiddlewareScopeFallback = (to: RouteLocationNormalizedGeneric): void => {
  const customerStore = useCustomerStore()
  const kidStore = useKidStore()
  const disciplineStore = useDisciplineStore()

  const customer = customerStore.customer
  if (!customer) return
  if (resolveScope(to, customer)) return

  kidStore.hydrateFromStorage()

  const disciplineId = Number(to.query?.discipline_id) || null
  const queriedKid = disciplineId ? findKidByDisciplineId(customer.kids, disciplineId) : undefined
  const currentKid = customer.kids.find(kid => kid.id === kidStore.activeKidId)
  const kid = currentKid ?? queriedKid ?? customer.kids[0]
  if (!kid) return

  const queriedCode = kid.disciplines.find(discipline => discipline.id === disciplineId)?.code
  const code: Discipline = disciplineStore.activeCode ?? queriedCode ?? getHomeDisciplineCode(kid)

  const isScopeCurrent = kidStore.activeKidId === kid.id && disciplineStore.activeCode === code
  if (isScopeCurrent) return

  disciplineStore.setScope({ kidId: kid.id, code })
}
